import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'; // Import your main application component
import './index.css'; // Import your CSS styles if needed

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);